/**
 * useTokenPricing：可编辑单价（仅 localStorage，不打后端）。
 * 数据流：TokenPriceCalculator 读写本模块 → estimateCost 按租户累计 Token 估算费用。
 * 注意：纯前端估算，真实计费以后端账本为准；改 KEY 结构时记得升版本号。
 */
const KEY = "billing.token_price.v1";

export type TokenPrice = {
  /** 每 1K input token 价格 */
  inputPer1k: number;
  /** 每 1K output token 价格 */
  outputPer1k: number;
};

const DEFAULT: TokenPrice = { inputPer1k: 0.001, outputPer1k: 0.002 };

/** 读本地单价：未存过 / JSON 损坏 / 缺字段都回退 DEFAULT 合并 */
export function loadTokenPrice(): TokenPrice {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULT };
    return { ...DEFAULT, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULT };
  }
}

/** 持久化单价到 localStorage（仅本机生效，不同步后端） */
export function saveTokenPrice(p: TokenPrice): void {
  localStorage.setItem(KEY, JSON.stringify(p));
}

/** 费用 = in/1000*单价 + out/1000*单价 */
export function estimateCost(
  tokensIn: number,
  tokensOut: number,
  price: TokenPrice,
): number {
  return (tokensIn / 1000) * price.inputPer1k + (tokensOut / 1000) * price.outputPer1k;
}
